import { basicPath } from '../basicPath';

// Helper function to get the correct API path prefix based on domain
const getStudentsPath = (endpoint) => {
    const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
    const prefix = hostname.includes('readingplex') ? '/rp' : '/mp';
    return `${prefix}/students/${endpoint}`;
};

export const fetchStudentsAll = (params) => async (dispatch) => {
    const path = getStudentsPath('all');
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

// Member portal endpoints - parents can access these
export const fetchMemberStudentsRelevant = (params) => async (dispatch) => {
    const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
    const path = hostname.includes('readingplex')
        ? '/rp/member/students/relevant'
        : '/mp/member/students/relevant';
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

// Unified member portal - fetch students from both MathPlex and ReadingPlex
export const fetchMemberStudentsUnified = (params) => async (dispatch) => {
    const results = {
        mathplex: null,
        readingplex: null
    };

    try {
        // Fetch MathPlex students
        const mpPath = '/mp/member/students/relevant';
        const mpRes = await basicPath(dispatch, params, mpPath, 'get');
        if (mpRes && mpRes.status === 200) {
            results.mathplex = Array.isArray(mpRes.data) ? mpRes.data : [];
        }
    } catch (err) {
        console.log('[UNIFIED] MathPlex students fetch failed:', err);
    }

    try {
        // Fetch ReadingPlex students
        const rpPath = '/rp/member/students/relevant';
        const rpRes = await basicPath(dispatch, params, rpPath, 'get');
        if (rpRes && rpRes.status === 200) {
            if (rpRes.data && rpRes.data.students) {
                results.readingplex = {
                    students: rpRes.data.students || [],
                    books: rpRes.data.books || [],
                    bookLists: rpRes.data.bookLists || [],
                    bookListItems: rpRes.data.bookListItems || []
                };
            } else if (Array.isArray(rpRes.data)) {
                results.readingplex = {
                    students: rpRes.data || [],
                    books: [],
                    bookLists: [],
                    bookListItems: []
                };
            }
        }
    } catch (err) {
        console.log('[UNIFIED] ReadingPlex students fetch failed:', err);
    }

    return {
        status: 200,
        data: results
    };
}

export const fetchStudentsActive = (params) => async (dispatch) => {
    const path = getStudentsPath('active');
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

export const fetchStudentsEssential = (params) => async (dispatch) => {
    const path = getStudentsPath('essential');
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

export const fetchStudentsCenter = (params) => async (dispatch) => {
    const path = '/mp/students/center';
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

export const fetchStudentsUserIds = (params) => async (dispatch) => {
    const path = '/mp/students/user-ids';
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

export const updateStudentAttributes = (params) => async (dispatch) => {
    const path = getStudentsPath('attributes');
    const type = 'put';
    return await basicPath(dispatch, params, path, type);
}

export const updateStudentBinder = (params) => async (dispatch) => {
    const path = getStudentsPath('binder');
    const type = 'put';
    return await basicPath(dispatch, params, path, type);
}

export const updateStudentContract = (params) => async (dispatch) => {
    const path = getStudentsPath('contract');
    const type = 'put';
    return await basicPath(dispatch, params, path, type);
}

export const updateStudentStamps = (params) => async (dispatch) => {
    const path = getStudentsPath('stamps');
    const type = 'put';
    return await basicPath(dispatch, params, path, type);
}

export const updateStudentHold = (params) => async (dispatch) => {
    const path = '/mp/students/holds';
    const type = 'put';
    return await basicPath(dispatch, params, path, type);
}